import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors, ValidatorFn
} from '@angular/forms';
import { TemplateService } from '../../../../services/template.service';
import { Subject, takeUntil } from "rxjs";
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
    selector: 'app-convert-legacy-template',
    imports: [
        NgIf,
        NgForOf,
        ReactiveFormsModule,
        NgSwitchCase,
        NgSwitch,
        NgSwitchDefault,
        ButtonDirective
    ],
    templateUrl: './convert-legacy-template.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './convert-legacy-template.component.scss'
})
export class ConvertLegacyTemplateComponent implements OnInit {
  protected legacyTemplate: IRecordDataModel;
  protected records: string[][];
  protected fieldNames: string[];
  protected oldFieldNames: string[];

  form!: FormGroup;
  protected variableOptions: { label: string; options: { label: string; value: string }[] }[] = [];
  protected templateName: string;
  private language: string;

  constructor(private router: Router, private fb: FormBuilder, protected templateService: TemplateService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.legacyTemplate = nav?.extras?.state?.['template'];
    this.templateName = nav?.extras?.state?.['templateName'];
    this.language = nav?.extras?.state?.['language'];


    console.log("template", this.legacyTemplate);
    console.log("templateName", this.templateName);
    console.log("language", this.language);

    this.fieldNames = this.legacyTemplate?.fieldNames ?? [''];
    this.oldFieldNames = this.legacyTemplate.fieldNames;
    this.records = this.legacyTemplate.records;
  }

  ngOnInit() {
    this.setVariableOptions();
    this.setForm(this.fieldNames);
  }

  // pomoćna metoda da izbjegnemo cast u templatu
  controls() {
    return (this.form.get('fieldNames') as FormArray<FormControl<string>>).controls;
  }

  saveKeys() {
    const updated = (this.form.get('fieldNames') as FormArray<FormControl<string>>).value as string[];
    this.fieldNames = updated;

    const fieldNamesWithCounter = this.addCounters(this.fieldNames)
    var recordData: IRecordDataModel = {
      fieldNames: fieldNamesWithCounter,
      records: this.records,
      mapTemplateName: null
    }

    this.templateService.convertTemplate(recordData, this.templateName, this.language)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          if (response) {
            console.log("got response:", response);
            const route = 'template/' + this.templateName
            this.router.navigate([route]);
          }
        },

        error: (error: any) => {
          console.error("Error converting template" + error);
        }
      })
  }

  addCounters(names: string[]): string[] {
    // vrijednosti koje NE dobivaju sufiks
    const whitelist = new Set([
      'ID_CUSTOM',
      'LANGUAGE',

      'CREATED_DATE_',
      'MODIFIED_DATE_',
    ]);

    const seen = new Map<string, number>();
    return names.map((name) => {
      if (whitelist.has(name)) return name; // preskoči sufiks

      const next = (seen.get(name) ?? 0) + 1; // 1, 2, 3, ...
      seen.set(name, next);
      return `${name}_${next}`;
    });
  }

  onSelect(index: number, value: string, oldValue: string): void {
    console.log("old value", oldValue)
    // const c = (this.form.get('fieldNames') as any).at(index);
    // c.markAsPristine();
    // c.markAsUntouched();
    // c.updateValueAndValidity();
    ///if oldValue contains number on the end of word ,concat this number as _number (_1,_2...) if no ,set _1 on value

    const old = (oldValue ?? '').trim();
    const m = old.match(/(\d+)$/); // broj na kraju riječi (npr. ..._12 -> "12")
    const suffix = m ? m[1] : '1';
    console.log("suffix: ", suffix);
    const next = new RegExp(`_${suffix}$`).test(value) ? value : `${value}_${suffix}`;


    const arr = this.form.get('fieldNames') as FormArray<FormControl<string>>;
    arr.at(index).setValue(value);
  }

  //
  // private setForm(fieldNames: string[]) {
  //   // 1) napravi formu s jednim FormArray za ključeve
  //   this.form = this.fb.group({
  //     fieldNames: this.fb.array<FormControl<string | null>>([])
  //   });
  //
  //   // 2) inicijaliziraj kontrole iz lokalnog this.fieldNames
  //   // const nameCtrls = (fieldNames ?? []).map(k => this.fb.control<string>(k ?? ''));
  //   // inicijalizacija s validatorom po kontroli
  //   const nameCtrls = (fieldNames ?? []).map(k =>
  //     this.fb.control<string | null>(k ?? '', {validators: [this.inOptionsValidator], nonNullable: false})
  //   );
  //   const fa = this.fb.array<FormControl<string | null>>(nameCtrls);
  //   this.form.setControl('fieldNames', fa);
  //   console.log("Form:", this.form.get('fieldNames') as FormArray);
  // }

  private setForm(fieldNames: string[]) {
    const ctrls = (fieldNames ?? []).map(k =>
      this.fb.control<string | null>(k ?? '', {validators: [this.inOptionsValidator]})
    );
    const fa = this.fb.array<FormControl<string | null>>(ctrls);

    this.form = this.fb.group({fieldNames: fa});
    fa.updateValueAndValidity({onlySelf: false, emitEvent: false});
  }

  private setVariableOptions() {
    this.variableOptions = variableOptions;
  }

  private inOptionsValidator: ValidatorFn = (control: AbstractControl) => {
    const v = (control.value ?? '').toString().trim();
    if (!v) return null;
    const allValues = this.variableOptions.flatMap(g => g.options.map(o => o.value));
    const ok = allValues.includes(v);
    return ok ? null : {notInOptions: true};
  };

  private _destroy$ = new Subject<void>();

}

//todo izdvojiti
export interface IRecordDataModel {
  fieldNames: string[];     // Backend dopušta string? -> dozvoli null ako može stići
  records: string[][];               // List<List<string>> -> string[][]
  mapTemplateName: unknown | null;   // object? -> unknown|null (ili any|null)
}

type VariableOption = { label: string; value: string };
type VariableGroup = { label: string; options: VariableOption[] };

export const variableOptions: VariableGroup[] = [
  {
    label: 'Voucher',
    options: [
      {label: 'VOUCHER_LINK', value: 'VOUCHER_LINK'},
      {label: 'VOUCHER_TEXT', value: 'VOUCHER_TEXT'},
      {label: 'VOUCHER_HEADING', value: 'VOUCHER_HEADING'},
      {label: 'VOUCHER_PARAGRAPH', value: 'VOUCHER_PARAGRAPH'},
      {label: 'VOUCHER_IMAGE', value: 'VOUCHER_IMAGE'},
      {label: 'VOUCHER_ALT', value: 'VOUCHER_ALT'},
      {label: 'VOUCHER_CTA_TEXT', value: 'VOUCHER_CTA_TEXT'}
    ]
  },
  {
    label: 'MainBanner',
    options: [
      {label: 'MAIN_BANNER_IMAGE_DESKTOP', value: 'MAIN_BANNER_IMAGE_DESKTOP'},
      {label: 'MAIN_BANNER_IMAGE_MOBILE', value: 'MAIN_BANNER_IMAGE_MOBILE'},
      {label: 'MAIN_BANNER_ALT', value: 'MAIN_BANNER_ALT'},
      {label: 'MAIN_BANNER_HREF', value: 'MAIN_BANNER_HREF'}
    ]
  },
  {
    label: 'ParagraphCta',
    options: [
      {label: 'INTRO_TEXT', value: 'INTRO_TEXT'},
      {label: 'MAIN_CTA_LINK', value: 'MAIN_CTA_LINK'},
      {label: 'MAIN_CTA_TEXT', value: 'MAIN_CTA_TEXT'}
    ]
  },
  {
    label: 'GiftVoucher',
    options: [
      {label: 'GIFT_VOUCHER_HEADING', value: 'GIFT_VOUCHER_HEADING'},
      {label: 'GIFT_VOUCHER_TEXT', value: 'GIFT_VOUCHER_TEXT'},
      {label: 'GIFT_VOUCHER_IMAGE', value: 'GIFT_VOUCHER_IMAGE'},
      {label: 'GIFT_VOUCHER_IMAGE_HREF', value: 'GIFT_VOUCHER_IMAGE_HREF'},
      {label: 'GIFT_VOUCHER_IMAGE_ALT', value: 'GIFT_VOUCHER_IMAGE_ALT'},
      {label: 'GIFT_VOUCHER_CTA_LINK', value: 'GIFT_VOUCHER_CTA_LINK'},
      {label: 'GIFT_VOUCHER_CTA_TEXT', value: 'GIFT_VOUCHER_CTA_TEXT'}
    ]
  },
  {
    label: 'Counter',
    options: [
      {label: 'COUNTDOWN_ALT', value: 'COUNTDOWN_ALT'},
      {label: 'COUNTDOWN_LINK', value: 'COUNTDOWN_LINK'},
      {label: 'COUNTDOWN_IMAGE', value: 'COUNTDOWN_IMAGE'}
    ]
  },
  {
    label: 'PropertyUsp2xPhoto',
    options: [
      {label: 'PROPERTY_USP_2X_1_IMAGE', value: 'PROPERTY_USP_2X_1_IMAGE'},
      {label: 'PROPERTY_USP_2X_2_IMAGE', value: 'PROPERTY_USP_2X_2_IMAGE'},
      {label: 'PROPERTY_USP_2X_1_IMAGE_HREF', value: 'PROPERTY_USP_2X_1_IMAGE_HREF'},
      {label: 'PROPERTY_USP_2X_2_IMAGE_HREF', value: 'PROPERTY_USP_2X_2_IMAGE_HREF'},
      {label: 'PROPERTY_USP_2X_1_IMAGE_ALT', value: 'PROPERTY_USP_2X_1_IMAGE_ALT'},
      {label: 'PROPERTY_USP_2X_2_IMAGE_ALT', value: 'PROPERTY_USP_2X_2_IMAGE_ALT'},
      {label: 'PROPERTY_USP_2X_NAME', value: 'PROPERTY_USP_2X_NAME'},
      {label: 'PROPERTY_USP_2X_1_USP', value: 'PROPERTY_USP_2X_1_USP'},
      {label: 'PROPERTY_USP_2X_2_USP', value: 'PROPERTY_USP_2X_2_USP'},
      {label: 'PROPERTY_USP_2X_3_USP', value: 'PROPERTY_USP_2X_3_USP'},
      {label: 'PROPERTY_USP_2X_CTA_LINK', value: 'PROPERTY_USP_2X_CTA_LINK'},
      {label: 'PROPERTY_USP_2X_CTA_TEXT', value: 'PROPERTY_USP_2X_CTA_TEXT'}
    ]
  },
  {
    label: 'PropertyUsp1xPhoto',
    options: [
      {label: 'PROPERTY_USP_1X_IMG_DESKTOP', value: 'PROPERTY_USP_1X_IMG_DESKTOP'},
      {label: 'PROPERTY_USP_1X_IMAGE_MOBILE', value: 'PROPERTY_USP_1X_IMAGE_MOBILE'},
      {label: 'PROPERTY_USP_1X_IMAGE_HREF', value: 'PROPERTY_USP_1X_IMAGE_HREF'},
      {label: 'PROPERTY_USP_1X_IMAGE_ALT', value: 'PROPERTY_USP_1X_IMAGE_ALT'},
      {label: 'PROPERTY_USP_1X_NAME', value: 'PROPERTY_USP_1X_NAME'},
      {label: 'PROPERTY_USP_1X_1_USP', value: 'PROPERTY_USP_1X_1_USP'},
      {label: 'PROPERTY_USP_1X_2_USP', value: 'PROPERTY_USP_1X_2_USP'},
      {label: 'PROPERTY_USP_1X_3_USP', value: 'PROPERTY_USP_1X_3_USP'},
      {label: 'PROPERTY_USP_1X_CTA_LINK', value: 'PROPERTY_USP_1X_CTA_LINK'},
      {label: 'PROPERTY_USP_1X_CTA_TEXT', value: 'PROPERTY_USP_1X_CTA_TEXT'}
    ]
  },
  {
    label: 'ZigZagNoHeadingNoButton',
    options: [
      {label: 'ZIG_ZAG_NHNB_IMAGE', value: 'ZIG_ZAG_NHNB_IMAGE'},
      {label: 'ZIG_ZAG_NHNB_IMAGE_HREF', value: 'ZIG_ZAG_NHNB_IMAGE_HREF'},
      {label: 'ZIG_ZAG_NHNB_IMAGE_ALT', value: 'ZIG_ZAG_NHNB_IMAGE_ALT'},
      {label: 'ZIG_ZAG_NHNB_TEXT', value: 'ZIG_ZAG_NHNB_TEXT'}
    ]
  },
  {
    label: 'ZigZagHeadingAndCta',
    options: [
      {label: 'ZIG_ZAG_HAC_HEADING', value: 'ZIG_ZAG_HAC_HEADING'},
      {label: 'ZIG_ZAG_HAC_IMAGE', value: 'ZIG_ZAG_HAC_IMAGE'},
      {label: 'ZIG_ZAG_HAC_IMAGE_HREF', value: 'ZIG_ZAG_HAC_IMAGE_HREF'},
      {label: 'ZIG_ZAG_HAC_IMAGE_ALT', value: 'ZIG_ZAG_HAC_IMAGE_ALT'},
      {label: 'ZIG_ZAG_HAC_CTA_LINK', value: 'ZIG_ZAG_HAC_CTA_LINK'},
      {label: 'ZIG_ZAG_HAC_CTA_TEXT', value: 'ZIG_ZAG_HAC_CTA_TEXT'},
      {label: 'ZIG_ZAG_HAC_TEXT', value: 'ZIG_ZAG_HAC_TEXT'}
    ]
  },
  {
    label: 'ZigZagHeadingAndAltCta',
    options: [
      {label: 'ZIG_ZAG_HAAC_HEADING', value: 'ZIG_ZAG_HAAC_HEADING'},
      {label: 'ZIG_ZAG_HAAC_IMAGE', value: 'ZIG_ZAG_HAAC_IMAGE'},
      {label: 'ZIG_ZAG_HAAC_IMAGE_HREF', value: 'ZIG_ZAG_HAAC_IMAGE_HREF'},
      {label: 'ZIG_ZAG_HAAC_IMAGE_ALT', value: 'ZIG_ZAG_HAAC_IMAGE_ALT'},
      {label: 'ZIG_ZAG_HAAC_CTA_LINK', value: 'ZIG_ZAG_HAAC_CTA_LINK'},
      {label: 'ZIG_ZAG_HAAC_CTA_TEXT', value: 'ZIG_ZAG_HAAC_CTA_TEXT'},
      {label: 'ZIG_ZAG_HAAC_TEXT', value: 'ZIG_ZAG_HAAC_TEXT'}
    ]
  },
  {
    label: 'PropertyDescription',
    options: [
      {label: 'PROPERTY_DESC_IMAGE_DESKTOP', value: 'PROPERTY_DESC_IMAGE_DESKTOP'},
      {label: 'PROPERTY_DESC_IMAGE_MOBILE', value: 'PROPERTY_DESC_IMAGE_MOBILE'},
      {label: 'PROPERTY_DESC_IMAGE_HREF', value: 'PROPERTY_DESC_IMAGE_HREF'},
      {label: 'PROPERTY_DESC_IMAGE_ALT', value: 'PROPERTY_DESC_IMAGE_ALT'},
      {label: 'PROPERTY_DESC_PROPERTY_NAME', value: 'PROPERTY_DESC_PROPERTY_NAME'},
      {label: 'PROPERTY_DESCRIPTION', value: 'PROPERTY_DESCRIPTION'},
      {label: 'PROPERTY_DESC_CTA_LINK', value: 'PROPERTY_DESC_CTA_LINK'},
      {label: 'PROPERTY_DESC_CTA_TEXT', value: 'PROPERTY_DESC_CTA_TEXT'}
    ]
  },
  {
    label: 'X2PropRec',
    options: [
      {label: 'X2_PROP_REC_1_IMAGE', value: 'X2_PROP_REC_1_IMAGE'},
      {label: 'X2_PROP_REC_2_IMAGE', value: 'X2_PROP_REC_2_IMAGE'},
      {label: 'X2_PROP_REC_1_IMAGE_HREF', value: 'X2_PROP_REC_1_IMAGE_HREF'},
      {label: 'X2_PROP_REC_2_IMAGE_HREF', value: 'X2_PROP_REC_2_IMAGE_HREF'},
      {label: 'X2_PROP_REC_1_IMAGE_ALT', value: 'X2_PROP_REC_1_IMAGE_ALT'},
      {label: 'X2_PROP_REC_2_IMAGE_ALT', value: 'X2_PROP_REC_2_IMAGE_ALT'},
      {label: 'X2_PROP_REC_1_DESTINATION', value: 'X2_PROP_REC_1_DESTINATION'},
      {label: 'X2_PROP_REC_2_DESTINATION', value: 'X2_PROP_REC_2_DESTINATION'},
      {label: 'X2_PROP_REC_1_NAME', value: 'X2_PROP_REC_1_NAME'},
      {label: 'X2_PROP_REC_2_NAME', value: 'X2_PROP_REC_2_NAME'},
      {label: 'X2_PROP_REC_1_CTA_LINK', value: 'X2_PROP_REC_1_CTA_LINK'},
      {label: 'X2_PROP_REC_2_CTA_LINK', value: 'X2_PROP_REC_2_CTA_LINK'},
      {label: 'X2_PROP_REC_1_CTA_TEXT', value: 'X2_PROP_REC_1_CTA_TEXT'},
      {label: 'X2_PROP_REC_2_CTA_TEXT', value: 'X2_PROP_REC_2_CTA_TEXT'}
    ]
  },
  {
    label: 'Heading',
    options: [{label: 'HEADING', value: 'HEADING'}]
  },
  {
    label: 'Reservation',
    options: [
      {label: 'RES_1_IMAGE', value: 'RES_1_IMAGE'},
      {label: 'RES_2_IMAGE', value: 'RES_2_IMAGE'},
      {label: 'RES_1_IMAGE_HREF', value: 'RES_1_IMAGE_HREF'},
      {label: 'RES_2_IMAGE_HREF', value: 'RES_2_IMAGE_HREF'},
      {label: 'RES_1_IMAGE_ALT', value: 'RES_1_IMAGE_ALT'},
      {label: 'RES_2_IMAGE_ALT', value: 'RES_2_IMAGE_ALT'},
      {label: 'RES_PROPERTY_NAME', value: 'RES_PROPERTY_NAME'},
      {label: 'RES_ADDRESS', value: 'RES_ADDRESS'},
      {label: 'RES_TELEPHONE', value: 'RES_TELEPHONE'},
      {label: 'RES_CHECK_IN', value: 'RES_CHECK_IN'},
      {label: 'RES_CHECK_OUT', value: 'RES_CHECK_OUT'}
    ]
  },
  {
    label: 'Event',
    options: [
      {label: 'EVENT_IMAGE_DESKTOP', value: 'EVENT_IMAGE_DESKTOP'},
      {label: 'EVENT_IMAGE_MOBILE', value: 'EVENT_IMAGE_MOBILE'},
      {label: 'EVENT_IMAGE_HREF', value: 'EVENT_IMAGE_HREF'},
      {label: 'EVENT_IMAGE_ALT', value: 'EVENT_IMAGE_ALT'},
      {label: 'EVENT_TEXT', value: 'EVENT_TEXT'},
      {label: 'EVENT_CTA_LINK', value: 'EVENT_CTA_LINK'},
      {label: 'EVENT_CTA_TEXT', value: 'EVENT_CTA_TEXT'}
    ]
  },
  {
    label: 'CheckIn',
    options: [
      {label: 'CHECK_IN_HEADING', value: 'CHECK_IN_HEADING'},
      {label: 'CHECK_IN_TEXT', value: 'CHECK_IN_TEXT'},
      {label: 'CHECK_IN_IMAGE', value: 'CHECK_IN_IMAGE'},
      {label: 'CHECK_IN_IMAGE_HREF', value: 'CHECK_IN_IMAGE_HREF'},
      {label: 'CHECK_IN_IMAGE_ALT', value: 'CHECK_IN_IMAGE_ALT'},
      {label: 'CHECK_IN_CTA_LINK', value: 'CHECK_IN_CTA_LINK'},
      {label: 'CHECK_IN_CTA_TEXT', value: 'CHECK_IN_CTA_TEXT'}
    ]
  },
  {
    label: 'ValamarApp',
    options: [
      {label: 'APP_HEADING', value: 'APP_HEADING'},
      {label: 'APP_TEXT', value: 'APP_TEXT'},
      {label: 'APP_IMAGE', value: 'APP_IMAGE'},
      {label: 'APP_IMAGE_HREF', value: 'APP_IMAGE_HREF'},
      {label: 'APP_IMAGE_ALT', value: 'APP_IMAGE_ALT'},
      {label: 'APP_CTA_1_LINK', value: 'APP_CTA_1_LINK'},
      {label: 'APP_CTA_2_LINK', value: 'APP_CTA_2_LINK'}
    ]
  },
  {
    label: 'X2Experiences',
    options: [
      {label: 'X2_EXP_PARAGRAPH', value: 'X2_EXP_PARAGRAPH'},
      {label: 'X2_EXP_1_IMAGE', value: 'X2_EXP_1_IMAGE'},
      {label: 'X2_EXP_2_IMAGE', value: 'X2_EXP_2_IMAGE'},
      {label: 'X2_EXP_1_IMAGE_HREF', value: 'X2_EXP_1_IMAGE_HREF'},
      {label: 'X2_EXP_2_IMAGE_HREF', value: 'X2_EXP_2_IMAGE_HREF'},
      {label: 'X2_EXP_1_IMAGE_ALT', value: 'X2_EXP_1_IMAGE_ALT'},
      {label: 'X2_EXP_2_IMAGE_ALT', value: 'X2_EXP_2_IMAGE_ALT'},
      {label: 'X2_EXP_1_DESCRIPTION', value: 'X2_EXP_1_DESCRIPTION'},
      {label: 'X2_EXP_2_DESCRIPTION', value: 'X2_EXP_2_DESCRIPTION'},
      {label: 'X2_EXP_1_HEADING', value: 'X2_EXP_1_HEADING'},
      {label: 'X2_EXP_2_HEADING', value: 'X2_EXP_2_HEADING'},
      {label: 'X2_EXP_1_CTA_LINK', value: 'X2_EXP_1_CTA_LINK'},
      {label: 'X2_EXP_2_CTA_LINK', value: 'X2_EXP_2_CTA_LINK'},
      {label: 'X2_EXP_1_CTA_TEXT', value: 'X2_EXP_1_CTA_TEXT'},
      {label: 'X2_EXP_2_CTA_TEXT', value: 'X2_EXP_2_CTA_TEXT'}
    ]
  },
  {
    label: 'Moments',
    options: [
      {label: 'MOMENTS_IMAGE_DESKTOP', value: 'MOMENTS_IMAGE_DESKTOP'},
      {label: 'MOMENTS_IMAGE_MOBILE', value: 'MOMENTS_IMAGE_MOBILE'},
      {label: 'MOMENTS_HREF', value: 'MOMENTS_HREF'},
      {label: 'MOMENTS_ALT', value: 'MOMENTS_ALT'}
    ]
  },
  {
    label: 'Reviews',
    options: [
      {label: 'REVIEWS_IMAGE', value: 'REVIEWS_IMAGE'},
      {label: 'REVIEWS_IMAGE_HREF', value: 'REVIEWS_IMAGE_HREF'},
      {label: 'REVIEWS_IMAGE_ALT', value: 'REVIEWS_IMAGE_ALT'},
      {label: 'REVIEWS_PROPERTY_NAME', value: 'REVIEWS_PROPERTY_NAME'},
      {label: 'REVIEWS_TEXT', value: 'REVIEWS_TEXT'}
    ]
  },
  {label: 'OnlyIntro', options: [{label: 'ONLY_INTRO', value: 'ONLY_INTRO'}]},
  {label: 'Subject', options: [{label: 'SUBJECT', value: 'SUBJECT'}]},
  {label: 'Preheader', options: [{label: 'PREHEADER', value: 'PREHEADER'}]},
  {
    label: 'OnlyCta',
    options: [
      {label: 'ONLY_CTA_LINK', value: 'ONLY_CTA_LINK'},
      {label: 'ONLY_CTA_TEXT', value: 'ONLY_CTA_TEXT'}
    ]
  },
  {
    label: 'Inspiration',
    options: [
      {label: 'INSPIRATION_1_IMAGE', value: 'INSPIRATION_1_IMAGE'},
      {label: 'INSPIRATION_2_IMAGE', value: 'INSPIRATION_2_IMAGE'},
      {label: 'INSPIRATION_1_IMAGE_HREF', value: 'INSPIRATION_1_IMAGE_HREF'},
      {label: 'INSPIRATION_2_IMAGE_HREF', value: 'INSPIRATION_2_IMAGE_HREF'},
      {label: 'INSPIRATION_1_IMAGE_ALT', value: 'INSPIRATION_1_IMAGE_ALT'},
      {label: 'INSPIRATION_2_IMAGE_ALT', value: 'INSPIRATION_2_IMAGE_ALT'},
      {label: 'INSPIRATION_1_HEADING', value: 'INSPIRATION_1_HEADING'},
      {label: 'INSPIRATION_2_HEADING', value: 'INSPIRATION_2_HEADING'},
      {label: 'INSPIRATION_1_CTA_LINK', value: 'INSPIRATION_1_CTA_LINK'},
      {label: 'INSPIRATION_2_CTA_LINK', value: 'INSPIRATION_2_CTA_LINK'},
      {label: 'INSPIRATION_1_CTA_TEXT', value: 'INSPIRATION_1_CTA_TEXT'},
      {label: 'INSPIRATION_2_CTA_TEXT', value: 'INSPIRATION_2_CTA_TEXT'}
    ]
  },
  {
    label: 'X3Experiences',
    options: [
      {label: 'X3_EXP_1_IMAGE', value: 'X3_EXP_1_IMAGE'},
      {label: 'X3_EXP_2_IMAGE', value: 'X3_EXP_2_IMAGE'},
      {label: 'X3_EXP_3_IMAGE', value: 'X3_EXP_3_IMAGE'},
      {label: 'X3_EXP_1_IMAGE_HREF', value: 'X3_EXP_1_IMAGE_HREF'},
      {label: 'X3_EXP_2_IMAGE_HREF', value: 'X3_EXP_2_IMAGE_HREF'},
      {label: 'X3_EXP_3_IMAGE_HREF', value: 'X3_EXP_3_IMAGE_HREF'},
      {label: 'X3_EXP_1_IMAGE_ALT', value: 'X3_EXP_1_IMAGE_ALT'},
      {label: 'X3_EXP_2_IMAGE_ALT', value: 'X3_EXP_2_IMAGE_ALT'},
      {label: 'X3_EXP_3_IMAGE_ALT', value: 'X3_EXP_3_IMAGE_ALT'},
      {label: 'X3_EXP_1_HEADING', value: 'X3_EXP_1_HEADING'},
      {label: 'X3_EXP_2_HEADING', value: 'X3_EXP_2_HEADING'},
      {label: 'X3_EXP_3_HEADING', value: 'X3_EXP_3_HEADING'},
      {label: 'X3_EXP_1_CTA_LINK', value: 'X3_EXP_1_CTA_LINK'},
      {label: 'X3_EXP_2_CTA_LINK', value: 'X3_EXP_2_CTA_LINK'},
      {label: 'X3_EXP_3_CTA_LINK', value: 'X3_EXP_3_CTA_LINK'},
      {label: 'X3_EXP_1_CTA_TEXT', value: 'X3_EXP_1_CTA_TEXT'},
      {label: 'X3_EXP_2_CTA_TEXT', value: 'X3_EXP_2_CTA_TEXT'},
      {label: 'X3_EXP_3_CTA_TEXT', value: 'X3_EXP_3_CTA_TEXT'}
    ]
  },
  {
    label: 'X2PropRecOnp',
    options: [
      {label: 'X2_ONP_1_IMAGE', value: 'X2_ONP_1_IMAGE'},
      {label: 'X2_ONP_2_IMAGE', value: 'X2_ONP_2_IMAGE'},
      {label: 'X2_ONP_1_IMAGE_HREF', value: 'X2_ONP_1_IMAGE_HREF'},
      {label: 'X2_ONP_2_IMAGE_HREF', value: 'X2_ONP_2_IMAGE_HREF'},
      {label: 'X2_ONP_1_IMAGE_ALT', value: 'X2_ONP_1_IMAGE_ALT'},
      {label: 'X2_ONP_2_IMAGE_ALT', value: 'X2_ONP_2_IMAGE_ALT'},
      {label: 'X2_ONP_1_NAME', value: 'X2_ONP_1_NAME'},
      {label: 'X2_ONP_2_NAME', value: 'X2_ONP_2_NAME'},
      {label: 'X2_ONP_1_CTA_LINK', value: 'X2_ONP_1_CTA_LINK'},
      {label: 'X2_ONP_2_CTA_LINK', value: 'X2_ONP_2_CTA_LINK'},
      {label: 'X2_ONP_1_CTA_TEXT', value: 'X2_ONP_1_CTA_TEXT'},
      {label: 'X2_ONP_2_CTA_TEXT', value: 'X2_ONP_2_CTA_TEXT'},
      {label: 'X2_ONP_1_OLD_PRICE', value: 'X2_ONP_1_OLD_PRICE'},
      {label: 'X2_ONP_1_NEW_PRICE', value: 'X2_ONP_1_NEW_PRICE'},
      {label: 'X2_ONP_2_OLD_PRICE', value: 'X2_ONP_2_OLD_PRICE'},
      {label: 'X2_ONP_2_NEW_PRICE', value: 'X2_ONP_2_NEW_PRICE'}
    ]
  },
  {
    label: 'Only2Photos',
    options: [
      {label: 'FIRST_IMAGE', value: 'FIRST_IMAGE'},
      {label: 'SECOND_IMAGE', value: 'SECOND_IMAGE'},
      {label: 'FIRST_IMAGE_HREF', value: 'FIRST_IMAGE_HREF'},
      {label: 'SECOND_IMAGE_HREF', value: 'SECOND_IMAGE_HREF'},
      {label: 'FIRST_IMAGE_ALT', value: 'FIRST_IMAGE_ALT'},
      {label: 'SECOND_IMAGE_ALT', value: 'SECOND_IMAGE_ALT'}
    ]
  },
  {
    label: 'Concierge',
    options: [
      {label: 'CONCIERGE_IMAGE', value: 'CONCIERGE_IMAGE'},
      {label: 'CONCIERGE_IMAGE_HREF', value: 'CONCIERGE_IMAGE_HREF'},
      {label: 'CONCIERGE_IMAGE_ALT', value: 'CONCIERGE_IMAGE_ALT'},
      {label: 'CONCIERGE_HEADING', value: 'CONCIERGE_HEADING'},
      {label: 'CONCIERGE_TEXT', value: 'CONCIERGE_TEXT'}
    ]
  },
  {
    label: 'Disclaimer',
    options: [{label: 'DISCLAIMER', value: 'DISCLAIMER'}]
  }
];
